/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import { BHP_INTERFACE, DOCUMENT_INTERFACE } from "@Services/Application/Interfaces/Users/User";
import getObjectKeyValue from "@Utilities/Object/GetKeyValue";
import dateFormat from "dateformat";
import React from "react";


import {Button, Col, Row} from "react-bootstrap";
import QuizLinkComponent from "../QuizLink";

const DOCUMENTS_TYPES: any = {
    "B": "Szkolenie BHP"
};

type BhpCourseProps = {
    BHP_COURSE: BHP_INTERFACE;
};

export const BhpCourseComponent: React.FC<BhpCourseProps> = ({
    BHP_COURSE
}): JSX.Element | null => {

    const {
        //Type: documentType,
        DocNo: documentNumber, TerminalMasterNo: documentTerminal, Expire: documentExpireDate, ExpirePeriod: documentExpirePeriod
    } = BHP_COURSE;
   
    return (
        <Col xs={12} className={"user-information-section-component user-information-section user-document-data"}>
            <Row className={"user-information-section-content"}>
                <Col xs={8} className={"user-information-section-content"}>
                    <Col xs={12} className={"user-information-data user-important-information user-document-name no-margin-bottom"}>
                        {<span>{getObjectKeyValue(DOCUMENTS_TYPES, BHP_COURSE?.Type)}</span>}
                    </Col>
                    <Col xs={12} className={"user-information-data user-document-number medium-margin-bottom"}>
                        <span className={"information-label"}>{`baza paliw`}:</span>
                        <span className={"information-value"}>{documentTerminal}</span>
                    </Col>
                    <Col xs={12} className={"user-information-data user-document-number"}>
                        <span className={"information-label"}>{`numer`}:</span>
                        <span className={"information-value"}>{documentNumber || '-'}</span>
                    </Col>
                    <Col xs={12} className={"user-information-data user-document-valid-date"}>
                        <span className={"information-label"}>{`ważny do`}:</span>
                        <span className={"information-value"}>{documentExpireDate == undefined ? '-' : dateFormat(documentExpireDate, "dd-mm-yyyy")}</span>
                    </Col>
                </Col>
                <Col xs={4} className={"user-information-section-content d-flex justify-content-center align-items-center text-center"}>
                    <QuizLinkComponent EXPIRE={documentExpireDate} EXPIREPERIOD={documentExpirePeriod} TERMINALNO={documentTerminal}/>
                </Col>
            </Row>
        </Col>
    );

};

export default BhpCourseComponent;
